<template>
  <div class="input" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />
    <div :class="controlClasses">
      <BaseDatePicker
        :id="id"
        v-model="text"
        :min-date="minDate"
        :max-date="maxDate"
        :error="error"
        :disabled="disabled"
        @input="$emit('input', text)"
      />
    </div>
    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseDatePicker from "@/components/Base/Controls/BaseDatePicker";
import moment from "moment";

export default {
  name: "DateControl",
  components: {
    BaseDatePicker
  },
  extends: BaseFormControl,
  props: {
    value: {
      type: [String, Date]
    },
    minDate: {
      type: [String, Object],
      default: () => moment().format("YYYY-MM-DD")
    },
    maxDate: {
      type: [String, Object],
      default: () =>
        moment()
          .add("1", "years")
          .format("YYYY-MM-DD")
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: this.value
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue != oldValue) {
        this.text = newValue;
      }
    }
  }
};
</script>
